import React from 'react';
import ServiceCard from './ServiceCard';
import { Target, Share2, TrendingUp, Users, Search, BarChart3, Code, Layout, Lightbulb } from 'lucide-react';

const services = [
  {
    icon: Target,
    title: 'Marketing Strategy',
    description: 'Creating an effective marketing strategy for a startup is essential for building brand awareness, acquiring customers, and ultimately, achieving growth. We help you create the right strategy which becomes the foundation for future growth.',
    features: [
      'Brand strategy',
      'Brand messaging',
      'Competition analysis',
      'Market selection',
      'Monetization strategy',
      'Go-to-market strategy',
      'CMO for hire'
    ],
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978'
  },
  {
    icon: Share2,
    title: 'Content Marketing',
    description: 'Quality content is the defining factor that differentiates between a good brand and a great one. Upscale can help create engaging content that represents the brand voice and generates early adopter leads and sales. Content that actually converts.',
    features: [
      'Social media content management',
      'Influencer marketing',
      'Email marketing',
      'Content strategy & production',
      'Blogs and testimonials'
    ],
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f'
  },
  {
    icon: TrendingUp,
    title: 'Performance Marketing',
    description: 'At Upscale we are passionate about conversion rate. We work with one goal in mind - to create the best possible results at the lowest cost per conversion. We achieve this by focusing on the right target audience with the most relevant message in the most engaging format.',
    features: [
      'Google Adwords',
      'Facebook & Instagram Campaigns',
      'TikTok Ads',
      'LinkedIn Lead Generation Ads',
      'Campaign Creatives & Assets',
      'Campaign Optimization',
      'Campaign Analytics'
    ],
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71'
  },
  {
    icon: Users,
    title: 'Lead Generation',
    description: 'At Upscale, we specialize in prospecting and lead generation. Using the latest CRM tools like Hubspot, we will take care of end-to-end lead generation for you to ensure your sales team has a steady stream of leads to convert.',
    features: [
      'Buyer Journey Mapping',
      'Content Strategy',
      'Landing Page Optimization',
      'CRM Integration - Hubspot',
      'Lead Generation Campaigns',
      'Marketing Automation',
      'Tracking & Analytics'
    ],
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72'
  },
  {
    icon: Search,
    title: 'SEO & Search Engine Marketing',
    description: "In today's competitive digital landscape, a strong online presence is crucial for any business. Search engine optimization (SEO) plays a pivotal role in achieving this goal, helping your website rank higher in search engine results pages (SERPs) and attract a steady stream of qualified leads.",
    features: [
      'Keyword Research',
      'On-page Content Optimization',
      'User Experience Optimization',
      'Link Building',
      'Google Search Ads - SEM',
      'Campaign Set-up',
      'Campaign Optimization',
      'Conversion Tracking'
    ],
    image: 'https://images.unsplash.com/photo-1571721795195-a2ca2d3370a9'
  },
  {
    icon: BarChart3,
    title: 'Data Analytics & Tracking',
    description: 'We help you set-up the important KPIs tracking to get the insight you need to make the right decisions. What is the right next step? How do you achieve the goals you have set for your company? Order an analysis from our data and insights team or let us contribute as part of your marketing team.',
    features: [
      'Goals & KPIs set-up',
      'Conversion Tracking with Google Analytics 4',
      'Conversion Rate Optimization',
      'Product Analytics & User Behaviour Tracking',
      'Market Research',
      'Usability Survey'
    ],
    image: 'https://images.unsplash.com/photo-1686061593213-98dad7c599b9'
  },
  {
    icon: Code,
    title: 'Web Development',
    description: 'Do you have plans for a website redesign, or wondering how to make your existing site mobile responsive? We have extensive experience from web projects and know how to design and develop a website that is user friendly and mobile first. Upscale can also help with audit of your current website.',
    features: [
      'Custom Website Design & Development',
      'Responsive Web Design',
      'E-commerce store development - Shopify',
      'CMS Development',
      'Web Content Management',
      'Front-end Development',
      'Back-end Development'
    ],
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085'
  },
  {
    icon: Layout,
    title: 'UI-UX Audit',
    description: 'A User Interface and User Experience Audit (UI-UX Audit) thoroughly inspects your interface for any usability issues and recommends areas of improvement. The review depends on your project goals and uses empirical methods and offers heuristics-based recommendations.',
    features: [
      'User Experience (UX) Evaluation',
      'User Interface (UI) Design Assessment',
      'Accessibility and Inclusivity Review',
      'Performance and Usability Analysis',
      'Competitor Analysis and Benchmarking'
    ],
    image: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e'
  },
  {
    icon: Lightbulb,
    title: 'Strategy and Branding',
    description: "Welcome to Upscale's Strategy and Branding service – where your brand's success story begins. Our expert team specializes in crafting impactful strategies and refining brand identities to resonate with your target audience.",
    features: [
      'Brand Identity Development',
      'Market Research and Analysis',
      'Brand Strategy Development',
      'Digital Marketing Strategy',
      'Brand Experience Design'
    ],
    image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984'
  }
];

const ServicesList = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto space-y-24">
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            service={service}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesList;